import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import axios from "axios";
import CustomHeader from "../components/Header";
import {
  CardDeck,
  Row,
  Col,
  Container,
  Card,
  Modal,
  Button,
} from "react-bootstrap";

import Select from "react-select";
import GroupVRNSelect from "../containers/comps/GroupVRNSelectContainer";
import AdvanceTableWithActionButton from "../components/Tables/AdvanceTableWithActionButton";
import Swal from "sweetalert2/dist/sweetalert2.js";
import axiosConfig from "../config/axiosConfig";

const todayDate = new Date();
const customStyles = {
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? "black" : "black",
    backgroundColor: state.isSelected ? "#7367f0" : "white",
  }),
  control: (provided) => ({
    ...provided,
    borderRadius: "20px",
    borderColor: "#7367f0",
  }),
};

const headers = {
  "Content-Type": "application/json",
  APIkey: "C5BFF7F0-B4DF-475E-A331-F737424F013C",
};

class AdhocActivity extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      Others: "",
      middleName: "",
      lastName: "",
      email: "",
      mobileNo: "",

      groups: [],
      vrnOptions: [],
      maintenanceActivity: [],
      OthersActivity:true,
      OthersActivityComments:'',

      VRNMappingId:'',
      ActivityId:'',
      ActivityDate:'',
      ReminderOdometer:'0',
      ReminderDate:'',
      Comments:'',
      AvglastOdometerReading:'',
       
 
    };


    this.onActivityChange=this.onActivityChange.bind(this);
    this.changeGroup=this.changeGroup.bind(this);
    this.changeHandler_GetLastOdometerReading=this.changeHandler_GetLastOdometerReading.bind(this);
    this.changeHandler=this.changeHandler.bind(this);
    this.submitHandler=this.submitHandler.bind(this);
    this.changeVRN=this.changeVRN.bind(this);
    // this.changeHandler = this.changeHandler.bind(this);
    // this.handleSubmit = this.handleSubmit.bind(this);

    // this.changeGroup = this.changeGroup.bind(this);
    // this.onClickNext = this.onClickNext.bind(this);
    // this.onClickPrevious = this.onClickPrevious.bind(this);
    // this.changeVRN=this.changeVRN.bind(this);
    // this.onActivityChange=this.onActivityChange.bind(this);
    // this.callbackfunction_SMSalert=this.callbackfunction_SMSalert.bind(this);
    // this.callbackfunction_Emailalert=this.callbackfunction_Emailalert.bind(this);
    // this.changeHandler_GetLastOdometerReading=this.changeHandler_GetLastOdometerReading.bind(this);
    // this.callbackfunction_PushAlert=this.callbackfunction_PushAlert.bind(this);
    // this.SetSMSCheck=this.SetSMSCheck.bind(this);
    // this.SetEmailCheck=this.SetEmailCheck.bind(this);
    // this.changeHandlerDate=this.changeHandlerDate.bind(this);
    // this.setTodayDate=this.setTodayDate.bind(this);
  }

  componentDidMount() {
    this.setTodayDate();
    const data = {
      UserBranchID:this.props.data.selectedBranchId,
    };
    axiosConfig
      .post("Portal/GetVRNGroupMapping", data)
      .then((res) => {
        for (var i = 0; i < res.data.groupVRN.length; i++) {
          this.setState((prevState) => ({
            groups: [
              ...prevState.groups,
              {
                value: res.data.groupVRN[i].groupID,
                label: res.data.groupVRN[i].groupName,
                vrn: res.data.groupVRN[i].vrnModel,
              },
            ],
          }));
        }
      })
      .catch(function (error) {});

    /*Get Maintenance Activity*/
    axiosConfig
      .post("Portal/GetMaintenanceActivity")
      .then((res) => {
        for (var i = 0; i < res.data.maintenanceActivity.length; i++) {
          this.setState((prevState) => ({
            maintenanceActivity: [
              ...prevState.maintenanceActivity,
              {
                value: res.data.maintenanceActivity[i].id,
                label: res.data.maintenanceActivity[i].maintenanceActivity,
              },
            ],
          }));
        }
      })
      .catch(function (error) {});
  }

  changeGroup(selectedOption) {
    console.log(selectedOption);
    var tmpArray = [];
    console.log(tmpArray);

    this.setState(
      {
        vrnOptions: [],
      },
      function () {
        let tmpArray = this.state.groups.find(
          (groupid) => groupid.value === selectedOption.value
        );
        tmpArray.vrn.map((el, index) => {
          this.setState((prevState) => ({
            vrnOptions: [
              ...prevState.vrnOptions,
              {
                value: el.mappingID,
                label: el.vrn,
              },
            ],
          }));
        });
      }
    );
  }
  async changeVRN(selectedOption) {
   await this.setState({
    VRNMappingId:selectedOption.value,
    });
  }

  async setTodayDate() {
    let year = todayDate.getUTCFullYear();
    let month = todayDate.getUTCMonth() + 1;
    if (month < 10) {
      month = "0" + month;
    }
    let day = todayDate.getDate();

    let _today = year + "-" + month + "-" + day;
    await this.setState({ mindate: _today });
  }


  async onActivityChange(selectedOption){

    if(selectedOption.label==="Other")
    {
      await this.setState({
        OthersActivity:true
      });
    }
    else
    {
      await this.setState({
        OthersActivity:false
      });
    }

    await this.setState({
        //activityText:selectedOption.label,
        ActivityId:selectedOption.value,
        
      });
}

async changeHandler_GetLastOdometerReading(p) {
    await this.setState({
      ActivityDate:p.target.value
    });
    
    const data = {
      MappingID: this.state.VRNMappingId,
      ActivityDate: this.state.ActivityDate
    };
    axiosConfig
      .post("Portal/GetLastOdomemeter", data)
      .then((res) => {
        
        this.setState({
          AvglastOdometerReading:res.data.odometer
        });
      })
      .catch(function (error) {});

  }


  async submitHandler(e){

   
    /*Added By Ishfaque Kazi on 26th of August  2021*/
    
    e.preventDefault();
    let token=localStorage.getItem('token');
    let cards = []
    /*start*/
    debugger;
  
    let today=this.state.ActivityDate;
    let date="";
    
    var ActivityDate = this.state.ActivityDate.split("T");

    var reminderOdo = (this.state.ReminderOdometer == '') ? "0" : this.state.ReminderOdometer;

    axiosConfig.post("Portal/AddVehicleMaintenanceAdHoc",
            {

                ActivityID:this.state.ActivityId,
                OtherActivityName:this.state.OthersActivityComments,
                VRNMappingID:this.state.VRNMappingId,
                ActivityOdometer:this.state.AvglastOdometerReading,
                ActivityDateTime:ActivityDate[0] +" "+ActivityDate[1],
                Comments:this.state.Comments
            }
        )
        .then(Response => {
            Swal.fire({
                icon: 'success',
                title: 'Saved Successfully',
            })
        })
        .catch(error => {
            Swal.fire({
                title: error.response.data.errorMessage,
                text: 'Some Error !',
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        })
    /*End*/
    
  };
  changeHandler(p) {

    if(p.target.name == "AvglastOdometerReading")
    {
      p.target.value = p.target.value.replace(/[^0-9]/gi, "");
    }

    if(p.target.name == "Comments" || p.target.name == "OthersActivityComments")
    {
      p.target.value = p.target.value.replace(/[^a-zA-Z0-9\s]/gi, "");     
    } 

    var newState = {};
    newState[p.target.name] = p.target.value;
    this.setState(newState);

    
  }

  render() {

   

    const {  VRNMappingId,ActivityId, ActivityDate,Comments,OthersActivityComments,AvglastOdometerReadings} = this.state;
    return (
      <div>
        <CustomHeader></CustomHeader>
        <Row className="p-3">
          <Card className="p-3" style={{ width: "100%" }}>
            <Card.Title>
              <div className="pull-left">
                Adhoc Maintanance Activities
                <br></br>
                <small>{this.state.selectedVehicle}</small>
              </div>
            </Card.Title>

            <Card.Body>
              <Row>
                <div className="col-md-6 col-12">
                  <div className="form-group">
                    {/* <label htmlFor="ReportType">Choose Trend</label> */}
                    <p className="text-left">Vehicle Group</p>
                    <Select
                      className=""
                      options={this.state.groups}
                      styles={customStyles}
                      onChange={this.changeGroup}
                    ></Select>
                  </div>
                </div>

                <div className="col-md-6 col-12">
                  <div className="form-group">
                    {/* <label htmlFor="ReportType">Choose Trend</label> */}
                    <p className="text-left">Vehicle</p>
                    <Select
                      className=""
                      options={this.state.vrnOptions}
                      styles={customStyles}
                      onChange={this.changeVRN}
                    ></Select>
                  </div>
                </div>

                <div className="col-md-12 col-12">
                  <div className="form-group">
                    {/* <label htmlFor="ReportType">Choose Trend</label> */}
                    <p className="text-left">Choose Activity</p>
                    <Select
                      className=""
                      options={this.state.maintenanceActivity}
                      styles={customStyles}
                      onChange={this.onActivityChange}
                    ></Select>
                  </div>
                </div>
                {this.state.OthersActivity != false && (
                  <div className="col-md-6 col-12">
                    <div className="form-label-group">
                      <input
                        type="text"
                        id="OthersActivityComments"
                        name="OthersActivityComments"
                        value={this.state.OthersActivityComments}
                        onChange={this.changeHandler}
                        className="form-control"
                        maxLength="50"
                      />
                      <label htmlFor="city-column">Other's Activity </label>
                    </div>
                  </div>
                )}
                <div className="col-md-6 col-12">
                  <div className="form-label-group">
                    <input
                      type="datetime-local"
                      id="ActivityDate"
                      name="ActivityDate"
                      value={this.state.ActivityDate}
                      onChange={this.changeHandler_GetLastOdometerReading}
                      className="form-control"
                    />
                    <label htmlFor="city-column">
                      Pick date of last {this.state.activityText}{" "}
                    </label>
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <div className="form-label-group">
                    <input
                      type="text"
                      id="AvglastOdometerReading"
                      name="AvglastOdometerReading"
                      value={this.state.AvglastOdometerReading}
                      onChange={this.changeHandler}
                      className="form-control"
                      maxLength="7"
                    />
                    <label htmlFor="city-column">Last Odometer Reading </label>
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <div className="form-label-group">
                    <input
                      type="text"
                      id="Comments"
                      name="Comments"
                      value={this.state.Comments}
                      onChange={this.changeHandler}
                      className="form-control"
                      maxLength="100"
                    />
                    <label htmlFor="city-column">Comments </label>
                  </div>
                </div>

              
              </Row>
              <Row>
                    <div className="col-md-12 col-12" style={{ textAlign: 'center',marginTop: '8px' }}>
                          <button type="submit" className="btn btn-shell mr-1 mb-1" onClick={this.submitHandler} >Save</button>
                    </div>
              </Row>
              <br>
              </br>
              <br>
              </br>
              <br>
              </br>
              <br>
              </br>
            </Card.Body>
          </Card>
        </Row>
      </div>
    );
  }
}

export default AdhocActivity;
